var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5272_148709)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78.7113,
    cy: 88.7392,
    r: 57.8175,
    fill: "#262626",
    stroke: "white",
    strokeWidth: 5.50643
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.8164,
    y: 0.635742,
    width: 35.7918,
    height: 12.3895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.8301,
    y: 11.6489,
    width: 13.7661,
    height: 9.63625,
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.224 46.3724C154.999 75.0551 151.522 115.135 125.619 139.264C99.7152 163.393 58.6887 163.808 32.2707 139.679C6.2542 115.915 2.08755 75.5205 24.1131 46.6114C30.5886 38.8872 30.5635 38.2582 36.5252 33.918C46.8414 26.4077 58.2369 21.5643 71.1259 20.0799L71.4773 14.5195L59.4292 14.2427L59.2786 -0.740234H98.1464L98.0209 14.2301L86.161 14.5069L86.3116 20.0925C99.188 21.3756 110.684 26.6593 120.9 33.8174C127.225 38.8872 127.225 38.8872 133.224 46.3724ZM63.508 3.31057V10.0661L93.9672 10.1416V3.39863L63.508 3.32315V3.31057ZM81.9818 14.3559L75.4432 14.3811L75.4683 19.7151L82.0069 19.6899L81.9818 14.3559ZM143.176 88.6919C143.176 53.0021 114.311 24.0804 78.7187 24.0804C43.1265 24.0804 14.2486 53.0021 14.2486 88.6919C14.2486 124.382 43.114 153.304 78.7062 153.304C114.298 153.304 143.164 124.369 143.164 88.6919H143.176Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4531 50.8968C71.4531 47.2831 74.3827 44.3535 77.9965 44.3535V44.3535C81.6102 44.3535 84.5398 47.2831 84.5398 50.8968V81.6002H71.4531V50.8968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.236 116.393C113.347 118.582 113.284 122.068 111.095 124.179V124.179C108.907 126.29 105.421 126.228 103.309 124.039L77.7763 97.569L85.7025 89.9232L111.236 116.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 78.714,
    cy: 88.7392,
    r: 7.57134,
    stroke: "white",
    strokeWidth: 6.88303
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.224 46.3724C154.999 75.0551 151.522 115.135 125.619 139.264C99.7152 163.393 58.6887 163.808 32.2707 139.679C6.2542 115.915 2.08755 75.5205 24.1131 46.6114C20.0468 42.6109 19.4319 37.0505 22.9459 33.2765C26.4599 29.5024 32.4715 29.3011 36.5252 33.918C46.8414 26.4077 58.2369 21.5643 71.1259 20.0799L71.4773 14.5195L59.4292 14.2427L59.2786 -0.740234H98.1464L98.0209 14.2301L86.161 14.5069L86.3116 20.0925C99.188 21.3756 110.684 26.6593 120.9 33.8174C124.79 29.993 130.476 29.2634 134.015 32.8613C137.34 36.2328 138.457 41.6297 133.211 46.3724H133.224ZM63.508 3.31057V10.0661L93.9672 10.1416V3.39863L63.508 3.32315V3.31057ZM81.9818 14.3559L75.4432 14.3811L75.4683 19.7151L82.0069 19.6899L81.9818 14.3559ZM143.176 88.6919C143.176 53.0021 114.311 24.0804 78.7187 24.0804C43.1265 24.0804 14.2486 53.0021 14.2486 88.6919C14.2486 124.382 43.114 153.304 78.7062 153.304C114.298 153.304 143.164 124.369 143.164 88.6919H143.176ZM33.0739 36.7863C30.9278 34.2829 27.9409 34.2325 25.9705 36.4592C24.3515 38.2959 24.979 41.4535 26.9243 43.0009L33.0613 36.7863H33.0739ZM130.614 43.0764C131.492 41.9567 132.672 39.5539 132.433 38.2204C132.195 36.887 129.748 34.7483 128.392 34.7609C127.213 34.7609 125.205 35.9686 124.276 36.736L130.614 43.0764Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.1157,
    y: 1.32468,
    width: 60.5707,
    height: 11.0129,
    fill: "#262626",
    stroke: "#262626",
    strokeWidth: 4.12982
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5272_148709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTime);
export default __webpack_public_path__ + "static/media/add-time.2bc5ea9c61256cef2d77ef80e58f84de.svg";
export { ForwardRef as ReactComponent };